import { StyleSheet, View } from 'react-native';
import Dropdown from './Dropdown';

const SelectDropDown = ({
  label,
  dropDownContentWidth,
  fontSize,
  options,
  onSelect,
  defaultValue,
  customTopValue,
  color,
  fontWeight,
}) => {
  // eslint-disable-next-line

  return (
    <View style={styles.container}>
      <Dropdown
        label={label ? label : ''}
        data={options}
        onSelect={(value) => {
          onSelect(value);
        }}
        defaultValue={defaultValue}
        dropDownContentWidth={dropDownContentWidth}
        fontSize={fontSize}
        customTopValue={customTopValue}
        color={color}
        fontWeight={fontWeight}
      />
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    alignItems: 'center',
    justifyContent: 'center',
    flexDirection: 'column',
  },
});

export default SelectDropDown;
